<template>
  <div v-if="!this.enableAccessAuthCreate('B1', this.getUser.pref.select.cauth) !== true">
    <!-- <v-btn :color="ui.btnColor" flat dark @click="openDialog()"
    :disabled=" ">
      <v-icon left>
        add
      </v-icon>
      new
    </v-btn> -->
    <v-btn :color="ui.btnColor" flat dark @click="openDialog()"
    v-if="this.data.btnSize === 'flat'">
      <v-icon left>
        add
      </v-icon>
      New
    </v-btn>
    <v-btn :color="ui.bkgdColor" icon @click="openDialog()" v-else>
      <v-icon :color="ui.btnColor">
        add
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor"> add </v-icon>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                New Risk
              </div>
            </span>
            <v-spacer/>
            <v-icon :color="ui.btnColor"
            v-if="this.riskTitlePrefix === 'Facility'"> place </v-icon>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheadingBold">
              {{riskTitlePrefix}} {{stepInfo.title}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.msg}}
            </div>
          </v-layout>
          <v-form v-model="valid" lazy-validation>
            <v-container :class="ui.bkgdColor" v-if="this.step == 1">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.name"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="title"
                  hint="risk name or title"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.tag"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="fingerprint"
                  hint="risk id or tag"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 2">
              <v-layout row wrap class="ml-2 mr-2"
                v-if="this.riskTitlePrefix !== 'Facility'">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.itemLevel"
                    :items="levelOptions"
                    color="wplblue0"
                    prepend-icon="public"
                    hint="risk reach"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.theme"
                    :items="typeOptions"
                    color="wplblue0"
                    prepend-icon="grid_view"
                    hint="risk theme"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-1 mt-4 mr-1">
                <v-flex xs10 offset-xs1>
                  <v-textarea
                  :color="ui.textColor"
                  :background-color="ui.btnColor"
                  v-model="localForm.des"
                  label="risk description"
                  :disabled="false"
                  :outline="true"
                  :rules="ruleMustBeNotUndefinedANDLessThan2000"
                  hint="describe what happened with evidence"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 3">
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> account_balance </v-icon>
                  </v-avatar>
                  Company
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{getUser.pref.select.cname}}
                </v-chip>
              </v-layout>
              <div v-if="this.riskTitlePrefix === 'Facility'">
                <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> place </v-icon>
                    </v-avatar>
                    Facility
                  </v-chip>
                  <v-spacer/>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                  v-if="this.getUser.pref.select.fdid !== ''">
                    {{getUser.pref.select.fname}}
                  </v-chip>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                  v-else>
                    Not Selected
                  </v-chip>
                </v-layout>
                <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                      <v-icon> place </v-icon>
                    </v-avatar>
                    {{getUser.pref.select.fname}}
                  </v-chip>
                </v-layout>
              </div>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> emergency </v-icon>
                  </v-avatar>
                  Risk
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> emergency </v-icon>
                  </v-avatar>
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  Tag
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.tag}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  {{localForm.tag}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2"
              v-if="this.riskTitlePrefix !== 'Facility'">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> public </v-icon>
                  </v-avatar>
                  Impact
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.itemLevel}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> grid_view </v-icon>
                  </v-avatar>
                  Theme
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.theme}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Description
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{localForm.des}}
                </div>
              </v-layout>
              <!-- <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> adjust </v-icon>
                  </v-avatar>
                  Function
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.itemEngineeringClass}}
                </v-chip>
              </v-layout> -->
            </v-container>
          </v-form>

        </v-card-text>

        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          @click="previousStep(step)" :color="ui.btnColor" flat
          class="hidden-xs-only"
          >
            <v-icon left> navigate_before </v-icon>
            Back
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          @click="previousStep(step)" :color="ui.btnColor" flat
          class="hidden-sm-and-up">
            <v-icon> navigate_before </v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-xs-only">
            <v-icon left> navigate_next </v-icon>
            Next
          </v-btn>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-sm-and-up">
            <v-icon> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid"
          v-if="enableSubmit"
          @click="createNewRisk()" :color="ui.colorWarning" flat
          class="hidden-xs-only">
            <v-icon left> add </v-icon>
            Submit
          </v-btn>
          <v-btn :disabled="!valid"
          v-if="enableSubmit"
          class="hidden-sm-and-up"
          @click="createNewRisk()" :color="ui.colorWarning" flat>
            <v-icon> add </v-icon>
          </v-btn>
          <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnSpin from "@/frame/animation/components/BtnSpin";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import facilityOptions from "@/data/options/mixins/facilityOptions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import riskOptions from "@/data/options/mixins/riskOptions.js";
import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import moment from "moment";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import { mapGetters } from "vuex";

export default {
  components: {
    BtnSpin
  },
  // eslint-disable-next-line
  mixins: [
    getData,
    apptheme,
    adminFunctions,
    docRevsModFunctions,
    createFirebase,
    ruleTextfield,
    facilityOptions,
    storeFunctions,
    changeDetail,
    relationshipsFunctions,
    generateID,
    generateForms,
    accessFunctions,
    transFunctions,
    riskOptions
  ],
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      btnSpinChangeDetail: false,
      valid: true,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      },
      indeterminateProgressBar: false,
      step: 0,
      localForm: {
        name: "",
        tag: "",
        theme: "",
        des: ""
      },
      info: [
        {
          step: 0,
          title: "Risk Assessment or Opportunity",
          // eslint-disable-next-line
          msg: "Risk assessment is an essential business tool which allows to demonstrate to decision makers current and emerging opportunities and vulnerabilities which could impact company or specific facility. ",
          icon: ""
        },
        {
          step: 1,
          title: "Risk Info",
          // eslint-disable-next-line
          msg: "Risk or opportunity tag and name should be unique to enable efficient risk analysis with appropriate technical or business from subject matter experts.",
          icon: ""
        },
        {
          step: 2,
          title: "Risk Type",
          // eslint-disable-next-line
          msg: "Risk type specifies which who responsible for the identified risk together with risk control and mitigation management and remediation of risk exposure.",
          error: "",
          icon: ""
        },
        {
          step: 3,
          title: "Verify and Submit",
          // eslint-disable-next-line
          msg: "Verify entered information. Please return to previous steps if required.",
          error: "",
          icon: ""
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getFacility",
      "getCompany",
      "getCompanyDID",
      "getCurrentPage"
    ]),
    ui() {
      return this.uiTheme1;
    },
    stepInfo() {
      return this.info[this.step];
    },
    enableSubmit() {
      let logic = false;
      if (
        this.step === 3 &&
        this.btnSpinChangeDetail === false &&
        this.getCompanyDID !== null
      ) {
        logic = true;
      } else if (this.btnSpinChangeDetail === true) {
        logic = false;
      } else {
        logic = false;
      }
      return logic;
    },
    enableNextBtn() {
      let logic = false;
      if (this.step == 0) {
        logic = true;
      } else if (this.step == 1 && this.localForm.name !== "") {
        logic = true;
      } else if (
        this.step == 2 &&
        this.localForm.theme !== "" &&
        this.localForm.itemLevel !== "" &&
        this.localForm.des !== ""
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    riskTitlePrefix() {
      let title = null;
      if (this.getCurrentPage === "/facilitydashoperations") {
        title = "Facility";
      } else if (this.getCurrentPage === "/companydashsafety") {
        title = "Company";
      } else if (
        this.getRegisterInfo !== null &&
        this.getRegisterInfo.tag === "F1"
      ) {
        title = "Facility";
      } else {
        title = "Company";
      }
      return title;
    }
  },
  methods: {
    nextStep(step) {
      this.step = step + 1;
    },
    previousStep(step) {
      this.step = step - 1;
    },
    openDialog() {
      this.dialog = true;
      this.step = 0;
      this.btnSpinReadResult = false;
      // download facility which is used for asset
      // this.getDocumentFacilityOnly(this.getUser.pref.select.fdid);
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    createNewRisk() {
      this.btnSpinChangeDetail = true;
      // SET data source
      const tag = "B1";
      const did = this.generateDID("DATE", tag);
      const idg = this.generateIDG("date-gid");

      // GENERATE form
      let temp = this.generateRiskForm(); // form is from compnew component
      // ASSIGN data
      temp.basic.did = did;
      temp.basic.idg = idg;
      temp.basic.tag = tag;
      temp.basic.act = true; // set asset to true
      temp.basic.title = this.localForm.name;
      temp.basic.id = this.localForm.tag;

      // CHAR
      temp.char.theme = this.localForm.theme;
      temp.char.reach = this.localForm.itemLevel;
      temp.char.des = this.localForm.des;
      temp.char.time = "Continuous";
      temp.char.reach = "Facility";
      temp.char.spons = "Operations";
      temp.char.rec = "BAU";
      temp.char.dis = "General";

      // STATS
      temp.stats.dcrt = moment().format();
      // initial 1 month to complte risk assessment
      // eslint-disable-next-line
      temp.stats.drev = moment().add(1, 'months').format();

      // REV
      temp.rev = this.generateInitialDocumentRev(tag);

      // TRANS
      let trans = this.generateInitalTransition(tag); // model
      temp.trans = trans;

      // Link
      // Only select Facility if Parent is alos Facility select
      if (this.riskTitlePrefix === "Facility") {
        temp.char.reach = "Facility";
        let select = this.getUser.pref.select;
        temp.link.fdid = select.fdid;
        temp.link.ft = select.fname;
        temp.link.fid = select.fid;
        temp.link.fidg = select.fidg;
      }

      // HELP
      console.log("NEW RISK");
      console.log(temp);

      // Create Asset
      this.createFirebaseDocumentOnly(temp);
    }
  }
};
</script>
